export default {
  pma: {
    baseUrl: "http://pma.arrcencloud.net/Arrcen.PatientWebApiV3.2/",
    headers: {
      CurrentInstitutionId: "A18BA5FE-462E-410B-ADB4-499A6CEC1E21"
    },
    timeout: 20000
  },
  institution: {
    icon: require('../assets/images/内江六院.jpg'),
    hospitalNameCn: '内江市第六人民医院',
    hospitalNameEn: '',
    telephone: '0832-2210818',
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js